export const NotificationType = {
  COMMENT_MENTION: 'COMMENT_MENTION',
  COMMENT_REPLY: 'COMMENT_REPLY',
} as const;

export type NotificationType =
  (typeof NotificationType)[keyof typeof NotificationType];
